var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M765 4514 c-5 -1 -22 -5 -37 -8 -41 -9 -95 -61 -113 -109 -14 -38 -15 -183 -13 -1459 l3 -1416 31 -39 c55 -68 79 -76 250 -84 177 -9 226 -14 389 -40 440 -72 821 -252 1098 -518 l47 -45 0 1439 c0 792 -4 1457 -9 1478 -24 102 -259 362 -431 477 -255 169 -581 279 -920 309 -129 12 -280 19 -295 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4185 4510 c-420 -25 -755 -128 -1045 -321 -172 -113 -407 -374 -431 -476 -5 -21 -9 -686 -9 -1477 l0 -1439 53 49 c285 268 653 441 1092 513 163 26 212 31 389 40 171 8 195 16 250 84 l31 39 3 1411 c2 985 0 1423 -8 1449 -12 44 -52 93 -89 112 -40 21 -94 24 -236 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 3861 c-48 -22 -69 -44 -90 -94 -13 -32 -15 -208 -15 -1522 0 -1614 -3 -1523 53 -1583 54 -59 113 -66 269 -33 597 125 1225 142 1703 46 65 -13 121 -23 123 -21 6 7 -95 90 -178 145 -207 138 -474 236 -783 287 -48 8 -183 20 -300 28 -130 9 -228 20 -254 30 -140 50 -250 165 -293 305 -19 61 -20 99 -20 1247 l0 1184 -87 0 c-64 0 -99 -6 -128 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4800 2696 c0 -1148 -1 -1186 -20 -1247 -43 -140 -153 -255 -293 -305 -26 -10 -122 -21 -252 -30 -115 -7 -241 -18 -280 -24 -310 -48 -597 -152 -805 -291 -82 -55 -184 -138 -178 -145 2 -2 58 8 123 21 478 96 1106 79 1703 -46 156 -33 215 -26 269 33 56 60 53 -31 53 1585 0 1422 -1 1490 -19 1528 -36 78 -91 105 -216 105 l-85 0 0 -1184z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooks);
export default __webpack_public_path__ + "static/media/books.c9e10d3dcad630e816bf6c9d241b9b12.svg";
export { ForwardRef as ReactComponent };